var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabbed-page-layout',{staticClass:"workforce",attrs:{"title":"Arbejdsstyrke","pages":_vm.pages}},[_vm._t("tools",null,{"slot":"tools"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }